import * as Session from "./Session";

type PermissionConfig = { [resourceName: string]: string[] };
type OrFilter = { $or: FilterConfig[] };
type FilterConfig = PermissionConfig & OrFilter;

/**
 * Filters out contributions based on the current user's role permissions.
 *
 * Useful for things like hiding nav items from a non-admin user,
 *  or disabling certain parts of a view
 *
 * @filter permissions
 * @example
 * $filter: {
 *   permissions: {
 *     "user": ["gRead", "gUpdate"]
 *   }
 * }
 */
export const permissions = (config: FilterConfig): boolean => {
   return Object.keys(config).every((resourceName) => {
      // Note: $or clause is for backwards compatibility for cisco.dna.consumer-portal cisco.dna.pegasus plugins
      //  Please use top level $filter.$or instead
      if (resourceName === "$or") {
         return config[resourceName].some(permissions);
      } else {
         const operations = Session.getCurrentSession().match({
            some: (session) =>
               Session.permittedOperations(session, resourceName),
            none: () => [],
         });
         const requesting = config[resourceName] || [];
         return requesting.every((it) => operations.includes(it));
      }
   });
};
